import type { FC } from 'react';
import { useIntl } from 'react-intl';

import type { CompaniesIndustry } from '@xing-com/crate-common-graphql-types';

import { IndustryCard } from '../../components/industry-card/industry-card';
import { SubpageLayout } from '../../components/layouts/subpage-layout';
import { useCompaniesIndustries } from '../../hooks/use-companies-industries';
import { createCompaniesIndustries } from '../../models/industry';
import * as Styled from './new-industries.styles';

const LIMIT = 23;

export const NewIndustries: FC = () => {
  const { formatMessage } = useIntl();
  const { data, loading } = useCompaniesIndustries({
    limit: LIMIT,
  });

  const collection = (data?.companiesIndustries?.collection ??
    []) as CompaniesIndustry[];
  const industriesCollection = createCompaniesIndustries(collection);

  return (
    <SubpageLayout
      headerText={formatMessage({ id: 'CP_INDUSTRIES_SECTION_TITLE' })}
      description={formatMessage({ id: 'CP_INDUSTRIES_SECTION_SUBLINE' })}
    >
      <Styled.GridIndustries>
        {loading && (
          <>
            {Array.from({ length: LIMIT }).map((_, index) => (
              <IndustryCard.Skeleton key={index} />
            ))}
          </>
        )}
        {industriesCollection
          ?.sort((a, b) => a.title.localeCompare(b.title))
          .map((item) => (
            <IndustryCard key={item.id} item={item} />
          ))}
      </Styled.GridIndustries>
    </SubpageLayout>
  );
};
